import React, { useState } from 'react'
import Navbar from '../components/Navbar'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import { InfoContainer3, InfoWrapper, TextImageSection, TextBlock, ImageBlock, Tile, TilesContainer } from '../components/InfoSection/InfoElements'

import img1 from '../images/bizu/biżuteria 1.png'
import img2 from '../images/bizu/biżuteria 2.png'
import img3 from '../images/bizu/biżuteria 2 (2).png'
import img4 from '../images/bizu/biżuteria 2 (3).png'
import img5 from '../images/bizu/biżuteria 2 (4).png'
import img6 from '../images/bizu/biżuteria 2 (5).png'
import img7 from '../images/bizu/biżuteria 2 (6).png'
import img8 from '../images/bizu/biżuteria 2 (7).png'
import img9 from '../images/bizu/biżuteria 2 (8).png'
import img10 from '../images/bizu/biżuteria 2 (9).png'
import img11 from '../images/bizu/biżuteria 2 (10).png'
import img12 from '../images/bizu/biżuteria 2 (11).png'
import img13 from '../images/bizu/biżuteria 2 (12).png'
import img14 from '../images/bizu/biżuteria 2 (13).png'
import img15 from '../images/bizu/biżuteria 2 (14).png'
import img16 from '../images/bizu/biżuteria 2 (15).png'
import img17 from '../images/bizu/biżuteria 2 (16).png'
import img18 from '../images/bizu/biżuteria 2 (17).png'

const Bizu = () => {
    const [isOpen, setIsOpen] = useState(false)

    const toggle = () => {
        setIsOpen(!isOpen)
    }

const images = [
  img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12, img13, img14, img14, img16, img17, img18
  // ...reszta zdjęć
]

const [lightboxOpen, setLightboxOpen] = useState(false)
const [currentImg, setCurrentImg] = useState(null)

const openLightbox = (src) => {
  setCurrentImg(src)
  setLightboxOpen(true)
}

const closeLightbox = () => {
  setLightboxOpen(false)
  setCurrentImg(null)
}


  return (
    <>
    <Navbar toggle={toggle} />
    <Sidebar isOpen={isOpen} toggle={toggle} />
    <InfoContainer3 lightBg='true'>
                <InfoWrapper>
                  <div>
<TextImageSection>
                      <TextBlock>
                        <h2>Biżuteria</h2>
                        <p>
Poza pracą z ludźmi tworzę także biżuterię z naturalnych kamieni – z pasji i miłości do ich
piękna. Kamienie towarzyszyły mi od dnia narodzin. Zawsze fascynowało mnie to, że każdy
z nich jest inny – tak jak ludzie – i nosi w sobie własną historię oraz subtelną energię.</p>
                        <p>Bliska jest mi japońska poetyka wabi-sabi – zachwyt nad prostotą, niedoskonałością i
przemijaniem. Właśnie tę filozofię staram się przelewać na moje projekty biżuterii: tworzyć
rzeczy nieidealne, ale prawdziwe – pełne duszy, światła i znaczenia.</p>
<p>Każdy naszyjnik, bransoletka czy inny element, który wychodzi spod moich rąk, jest
osobistym talizmanem – symbolem domknięcia pewnego rozdziału i otwarcia się na nowy.
Wierzę, że to nasza intencja i myśl nadają kamieniom moc – czynią z nich ciche
przypomnienie tego, co ważne. A jednocześnie – że kamienie, dzięki swojej wyjątkowej
naturze, potrafią wspierać nas delikatną energią, z którą rezonują.</p>
<p>Dobieram kamienie intuicyjnie, wsłuchując się w historię i potrzeby osoby, dla której tworzę.
Do tej pory powstały dziesiątki, a może już setki takich talizmanów – i każdy z nich trafiał
dokładnie tam, gdzie trzeba.</p>
<p>Poniżej możesz zobaczyć przykładowe realizacje.</p>
<p>Jeśli czujesz, że chcesz zamówić swój osobisty talizman, możesz:– skontaktować się ze
mną przez formularz kontaktowy,– zadzwonić,– lub wybrać gotowy projekt ze sklepu (w
przygotowaniu).</p>                    
                      </TextBlock>
                      {/* <ImageBlock>
                        <img src={img5} alt="Atenida" />
                      </ImageBlock> */}
                    </TextImageSection>
                  </div>
                  <div
  style={{
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))",
    gap: "12px",
    marginTop: "30px",
    cursor: "pointer"
  }}
>
  {images.map((src, i) => (
    <div key={i}
      onClick={() => openLightbox(src)}
      style={{
        width: "100%",
        aspectRatio: "1/1",
        overflow: "hidden",
        borderRadius: "8px"
      }}
    >
      <img
        src={src}
        alt={`biżuteria-${i}`}
        loading="lazy"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: "block",
          transition: "transform 0.2s ease"
        }}
      />
    </div>
  ))}
</div>
                </InfoWrapper>
    </InfoContainer3>
    {lightboxOpen && (
  <div
    onClick={closeLightbox}
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0,0.85)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
      padding: "20px"
    }}
  >
    {/* X close button */}
    <div
      onClick={closeLightbox}
      style={{
        position: "absolute",
        top: "20px",
        right: "20px",
        fontSize: "32px",
        color: "#fff",
        cursor: "pointer",
        zIndex: 10000
      }}
    >
      ✕
    </div>

    <img
      src={currentImg}
      alt="lightbox"
      style={{
        maxWidth: "100%",
        maxHeight: "100%",
        objectFit: "contain",
        borderRadius: "8px"
      }}
      onClick={(e) => e.stopPropagation()} // Kliknięcie w zdjęcie NIE zamyka
    />
  </div>
)}
    <Footer />
    </>
  )
}

export default Bizu